export default "__VITE_ASSET__Dl_k611F__"